export default __webpack_public_path__ + "static/media/Companies_bg.d33e9600.png";